import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common/Loading";
import LockedView from "@/pages/public/LockedView";
import { PersonalProfileView } from "@/components/profile/PersonalProfileView";
import ProfileCrmPanel from "@/components/crm/ProfileCrmPanel";
import { EmptyState } from "@/components/common/Loading";
import { UserX } from "lucide-react";

export default function PublicProfile() {
  const { slug } = useParams();
  const { user, loading } = useAuth();
  const [data, setData] = useState(undefined);
  // Public Links: a signed-out visitor gets the allow-listed read-only card from the
  // SAME endpoint. A signed-in but unverified account keeps the existing locked view.
  const locked = !!user && !user.email_verified;
  // 403 `account_required` = the profile exists but its owner has not enabled a public
  // link. That is a sign-up prompt, not a dead end.
  const [needsAccount, setNeedsAccount] = useState(false);

  useEffect(() => {
    if (loading || locked) return;
    setData(undefined);
    setNeedsAccount(false);
    api.get(`/profile/public/${slug}`)
      .then((r) => setData(r.data))
      .catch((e) => {
        if (e?.response?.status === 403 && e?.response?.data?.detail === "account_required") {
          setNeedsAccount(true);
        }
        setData(null);
      });
  }, [user, loading, locked, slug]);

  if (loading) return <Loading />;
  if (locked) return <LockedView what="this profile" />;
  if (needsAccount) return <LockedView what="this profile" />;
  if (data === undefined) return <Loading />;
  if (data === null) return (
    <div className="mx-auto max-w-xl px-4 py-20"><EmptyState icon={UserX} title="Profile not found" description="This profile may be private or no longer exists." /></div>
  );
  return (
    <>
      {user && (
        <div className="mx-auto max-w-5xl px-4 pt-4">
          <ProfileCrmPanel profileUserId={data?.user_id} currentUserId={user?.user_id} />
        </div>
      )}
      <PersonalProfileView profile={data} currentUser={user} />
    </>
  );
}
